import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Input, Select, Button,Row,Col,message,Rate,Checkbox,Modal} from 'antd';
/** PERSONAL */
import API from '@/API/api';
import KnowledgeBox from './knowledge_box/view'
import Question from '@/entry_question_editor/question/question_view/view';

const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
let isOnComposition = false;

class HitTag extends Component {
    state = {
        question:{},
        tab:'normal',
        showAllTag:false,
        cateitemList:[],
        addWord:undefined,
        isShowModal:false,
        assWordChecked:undefined,
        submitType:undefined,
        cateitem_list_content:[]
    }
    componentWillMount() {
		this.getCateitemList()
    }
    componentDidUpdate(prevProps, prevState) {
        this.watchChange(this.props.question_id,prevProps.question_id,()=>{if(!this.props.question_id){this.setState({question:{} });};this.getQuestion()})//题目id改变 请求题目
    }
    watchChange = (val,newVal,fn,data)=>{
        if(val!==newVal){
            fn(data)
        }
    }
    //会认会写字列表
	getCateitemList(){
        axios.post(API.CATEITEM_LIST,{}).then((res)=>{
            res = res.data
            if (res.code === 0) {
            		this.setState({cateitemList:res.data})
            }else{
                message.error(res.message);
            }
        });
    }

    getQuestion = ()=>{
        if(!this.props.question_id){return}
        let task_id = window.location.href.split('/').pop()
        let data = {
            task_id:task_id,
            question_id:this.props.question_id,
        }
        axios.post(API.QSELECTTNEW_TASK_QUESTION_DETAIL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                let tab = 'normal'
                if(res.data.choice=='99'){
                    tab = 'bad'
                }
                this.setState({question:res.data,tab,cateitem_list_content:res.data.task_cateitem_list});
                document.querySelector('.app-container>div').scrollTop=0
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    submitCheck=(type)=>{
    		this.setState({submitType:type})
    		let params={
    			question_id:this.state.question.question_id,
    			task_id:window.location.href.split('/').pop(),
    			cateitem_list:this.state.cateitem_list_content
    		}
    		axios.post(API.ADD_NEW_WORD_CHECK,params).then(res=>{
    			res = res.data
    			if (res.code === 0) {
    				if(res.data.cateitem_list&&(res.data.cateitem_list.length==0||res.data.section.length==0)){
	                this.setTag (this.props.setTagSuccess,type)
	            }else{
	                this.setState({addWord:res.data,isShowModal:true})
	            }
    			}else{
    				 message.error(res.message);
    			}
			
		})
    }
    
    setTag (cb,str){
        let URL = API.QSELECTTNEW_TASK_QUESTION_SELECT_SUBMIT
        if(str==='check'){
             URL = API.QSELECTTNEW_TASK_QUESTION_CHECK_SUBMIT
        }
        let relate_list = []
        this.state.question.select.forEach((val)=>{
            let obj = {
                type:val.type,
                list:val.selected.map(d=>({well:d.well,id:d.id}))
            }
            relate_list.push(obj)
        })
        let section=this.state.addWord?this.state.addWord.section.filter(d=>{return this.state.assWordChecked.some(item=>item==d.section_id)}):undefined
        let data = {
            question_id:this.state.question.question_id,
            difficulty:+this.state.question.difficulty||1,
            display_type:this.state.question.display_type,
            relate_list:relate_list,
            tree_id:this.props.tree_id,
            task_id:window.location.href.split('/').pop(),
            error_status:this.state.error_info?1:0,
            error_info:this.state.error_info,
            choice:this.state.question.choice||'0',
            cateitem_list:this.state.cateitem_list_content,
            section:section
        }
        if(this.state.tab=='bad'){
            data.choice='99'
        }else{
        	   data.choice='0'
        }
        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message);
                this.setState({isShowModal:false})
                if(str!=='check'){
	                	cb&&cb(str)
	             }
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });

    }
    pass = (cb)=>{
        let URL = API.QSELECTTNEW_TASK_QUESTION_PASS
        let data = {
            question_id:this.state.question.question_id,
            task_id:window.location.href.split('/').pop(),
        }
        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message);
                cb&&cb()
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });

    }
    rework = (cb)=>{
        let reworkMessage = this.state.reworkMessage
        let mark = this.state.question.mark
        if ((!reworkMessage.length)&&mark === '') {
            message.error('请选择或填写返工原因')
            return
        }
        let URL = API.QSELECTTNEW_TASK_QUESTION_REWORK
        let data = {
            question_id:this.state.question.question_id,
            task_id:window.location.href.split('/').pop(),
            mark:`${reworkMessage.join(',')},${mark}`,
        }
        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message);
                cb&&cb()
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });

    }
     //修改
    editQuestion = (question_id) => {
        window.open(window.location.origin + `/question.html#/questionmanage/fillin/${question_id}`)
    }
    handleComposition = (e) => {
        if (e.type === 'compositionend') {
            isOnComposition = false;
        }else {
            isOnComposition = true;
        }
        
    }
    changeCateitemList=(str,e)=>{
        let cateitem_list_content = this.state.cateitem_list_content||[]
        let item = cateitem_list_content.find(d=>d.group==str)
        if(!item){
            item = {"group": str, "list":[]}
            cateitem_list_content.push(item)
        }
        item.list = e.target.value.split('|')
        if(e.target.value==''){item.list = []}
        if (!isOnComposition) {
        		this.setState({cateitem_list_content:cateitem_list_content})
        }

    }
    renderAddWordModal=()=>{
    		let {addWord,isShowModal,assWordChecked,submitType}=this.state,
    			{subject,setTagSuccess}=this.props
    		if((subject=='1'||subject=='2')&&addWord&&addWord.section.length>0){
    			return(
    				<Modal title="提示" visible={isShowModal} onOk={()=>this.setTag(setTagSuccess,submitType)} onCancel={()=>{this.setState({isShowModal:false, addWord:false})}}>
                    <div style={{padding:'10px 20px'}}>
                        {
                            addWord.cateitem_list.length>0&&
                            <div>
                                <span>您所添加的字/词：</span>
                                {addWord.cateitem_list.map(d=>
                                    (d.list.map(item=>
                                        <span>{item},</span>
                                    ))
                                )}
                                <span>尚未添加至字/词库中。</span>
                                <div>确定后，将字/词加入到词库。同时：</div>
                            </div>
                        }
                        <div>将字/词添加到以下章节</div>
                        <CheckboxGroup options={addWord.section.map(d=>({label:d.name,value:d.section_id}))}
                                       value={assWordChecked||(this.setState({assWordChecked:addWord.section.map(d=>d.section_id)}))&&addWord.section.map(d=>d.section_id)}
                                       onChange={(checkedValues)=>{this.setState({assWordChecked:checkedValues})}} />

                    </div>
                </Modal>
    			)
    		}else{
    			return null
    		}               
    }
    render() {
    		
    		let {question,showAllTag,tab,cateitemList,cateitem_list_content}=this.state
		
        let task_tag_type = showAllTag?false:this.props.task_tag_type
        if(!question.question_id){
            return (
            		<div>
	                <Col span={14} style={{ height: '100%'}}></Col>      
	                <Col span={10}>暂无题目</Col>
	            </div>
            )
            
        }

        return (

            <div>
                <Col span={14} style={{ height: '100%'}}>
                    {
                        question.question_id&&
                        <div style={{padding:10,paddingRight:'20px'}}>
                            <div style={{borderBottom:'1px solid #aaa'}}>
                                题目ID:{question.question_id}
                            </div>
                            <Question data={question} num={'undefined'}/>
                        </div>
                    }

                </Col>
                <Col span={10}>
                    <div style={{padding:10}}>
                        <div style={{borderBottom:'1px solid #aaa'}}>
                            题目详情
                            <Button style={{float:'right',transform: 'translateY(-2px)'}} size={'small'} type={showAllTag?'':'primary'} onClick={()=>{this.setState({showAllTag:!showAllTag})}}>显示全部标签</Button>
                        </div>
                        <div style={{padding:5}}>
                            <Row style={{padding:5}}>
                                <Col span={12}><Button style={{width:'100%'}} type={tab=='normal'?'primary':''} onClick={()=>{if(this.props.scene==='lookTask'){return};this.setState({tab:'normal'})}}>正常</Button></Col>
                                <Col span={12}><Button style={{width:'100%'}} type={tab=='bad'?'primary':''} onClick={()=>{if(this.props.scene==='lookTask'){return};this.setState({tab:'bad'})}}>坏题</Button></Col>
                            </Row>
                            <div style={tab==='normal'?{}:{display:'none'}}>
                                {question.mark&&
                                    <Row>
                                        <span>返工原因：</span>
                                        <span>{question.mark}</span>
                                    </Row>
                                }
                                {
                                    ( (!task_tag_type)||task_tag_type.some(d=>''+d==='-1')||task_tag_type.some(d=>''+d==='1') )&&
                                    <Row>
                                        <span style={{fontSize:13}}>题目难度：</span>
                                        <span>
                                        <Rate  onChange= {(val)=>{question.difficulty=val;this.forceUpdate()}}  value={ +question.difficulty||1 }count={4} disabled={this.props.scene==='lookTask'}/>
                                        </span>
                                    </Row>
                                }

       
                                {
                                    ( (!task_tag_type)||task_tag_type.some(d=>''+d==='-1')||task_tag_type.some(d=>''+d==='3') )&&
                                    <Row>
                                        <span style={{fontSize:13}}>展示类型：</span>
                                        <span>
                                        {
                                            question.displaytypelist&&
                                            (this.props.scene==='lookTask'?
                                                    <span>{
                                                        question.displaytypelist.find(d=>d.id==question.display_type)?
                                                            question.displaytypelist.find(d=>d.id==question.display_type).name:''
                                                    }
                                                </span>
                                                    :
                                                    <Select  value={''+question.display_type} style={{width: 80, marginLeft: 5}} onSelect={(val)=>{question.display_type=val;this.forceUpdate()}}>
                                                        {
                                                            question.displaytypelist.map((val,k)=>
                                                                <Select.Option key={k} value={val.id}>{val.name}</Select.Option>
                                                            )
                                                        }
                                                    </Select>
                                            )

                                        }
                                    </span>
                                    </Row>
                                }

                                {

                                    question.select&&question.select.length&&
                                        question.select.map((val,k)=>
                                                <Row key={k}>
                                                    {
                                                    ( (!task_tag_type)||
                                                        (task_tag_type.some(d=>''+d==='-1'))||
                                                        (
                                                            (val.type=='21'&&task_tag_type.some(d=>''+d==='4') )||//知识点
                                                            (val.type=='122'&&task_tag_type.some(d=>''+d==='5') )||//考点
                                                            (val.type=='24'&&task_tag_type.some(d=>''+d==='6') )//能力
                                                        )
                                                    )&&
                                                    <KnowledgeBox data={val} select={question.select}
                                                                  hideHistory={question.hide_history}
                                                                  changehideHistory={(val)=>{question.hide_history=val;this.setState({question:question}) }}
                                                                  historyData={question.recomend[val.type]}
                                                                  task_id={window.location.href.split('/').pop()} scene={this.props.scene}>
                                                    </KnowledgeBox>
                                                    }
                                                </Row>


                                        )

                                }
								
                             	{
			                        (!task_tag_type||task_tag_type.includes('-1')||task_tag_type.includes('7'))&&cateitemList.cateitem_group&&cateitemList.cateitem_group.map((item,i)=>
			                            <Row style={{marginTop:'20px'}} key={i}>
			                                <Col span={4} className="position_100">
			                                    <p className="item-title edit_title">{item.name}：</p>
			                                </Col>
			                                <Col span={10}>

			                                            <TextArea rows={4} key={1} 
			                                            	   onChange={(e)=>{this.changeCateitemList(item.group,e)}}
			                                                onCompositionEnd={this.handleComposition}
			                                                value={cateitem_list_content&&
			                                                cateitem_list_content.find((d)=>d.group===item.group)?cateitem_list_content.find((d)=>d.group===item.group).list.join('|'):''}
			                                            />

			
			                                </Col>
			                                <Col span={10}>
			                                    <span style={{marginLeft:'5px'}}>多个{item.name.slice(2)}之间用'|'隔开</span>
			                                </Col>
			                            </Row>
			                        )
			                    }
								{this.renderAddWordModal()}
                            </div>
                            <div style={tab==='bad'?{}:{display:'none'}}>
                                {question.mark&&
                                <Row>
                                    <span>返工原因：</span>
                                    <span>
                                        {question.mark}
                                    </span>
                                </Row>
                                }
                                {question.error_info&&
                                <Row>
                                    <span>坏题原因：</span>
                                    <span>
                                        {question.error_info}
                                    </span>
                                </Row>
                                }
                                {
                                <Row>
                                    <span>坏题原因：</span>
                                    <div>
                                        <Input.TextArea style={{margin: '10px 0'}}
                                                  value={this.state.error_info}
                                                  onChange={(e)=>{this.setState({error_info:e.target.value})}}
                                                  placeholder="坏题原因"
                                                  autosize={{ minRows: 2, maxRows: 6 }} />
                                    </div>
                                </Row>
                                }
                            </div>

                        </div>

                         
                        
                        {
                        	this.props.scene==='selectTask'&&
                            <div style={{textAlign:'right'}}>
                            		<Button style={{marginRight:'10px'}}  onClick= {() => this.editQuestion(question.question_id) }>改题</Button>
                            		<Button onClick={()=>{this.submitCheck()}}>保存</Button>
                            </div>
                        }
                        
                        {
                            this.props.scene==='checkTask'&&
                            <div style={{textAlign:'right'}}>
                                <Button style={{marginLeft:10}} onClick={ ()=>{ window.open(window.location.origin + `/question.html#/questionmanage/fillin/${question.question_id}`)} }>改题</Button>
                                <Button style={{marginLeft:10}} onClick={()=>{ this.pass(this.props.setTagSuccess)}}>通过</Button>
                                <Button style={{marginLeft:10}} onClick={() => this.setState({reworkModal: true})}>返工</Button>
                                <Button style={{marginLeft:10}} onClick={()=>{this.submitCheck('check')}}>提交编辑结果</Button>
                                
                                <Modal title="返工原因" visible={this.state.reworkModal} onOk={()=>{this.rework( ()=>{this.props.setTagSuccess();this.setState({reworkModal: false})} )}}
                                       onCancel={() => this.setState({reworkModal: false})}>
                                    <Checkbox.Group options={[
                                        {label: '未打全', value: '未打全'},
                                        {label: '知识点错误', value: '知识点错误'},
                                        {label: '考点错误', value: '考点错误'},
                                        {label: '能力错误', value: '能力错误'},
                                    ]} onChange={(vals)=>{this.setState({reworkMessage: vals})}}/>

                                    <Input style={{margin: '10px 0'}} value={question.mark||''} onChange={(e)=>{question.mark=e.target.value;this.forceUpdate()}}/>
                                </Modal>
                            </div>
                        }
                    </div>
                </Col>
            </div>
        )
    }
}

const mapStateTopProps = state => {
    return {
		subject:state.user.subject,
    }
}
const mapDispatchToProps = dispatch => {
    return {

    }
};
export default connect(mapStateTopProps, mapDispatchToProps)(HitTag);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/question_tag_detail/view.js